export default __webpack_public_path__ + "dist/media/Go-back-button.7a24c99b.svg";